import dayjs from 'dayjs';

export const checkSwitchDisableStatus = (currentFilter, filters) =>
    !currentFilter && Object.keys(filters).some(key => filters[key]);

export const badgesFilter = (initField, [key, value], acc, name) => {
    if ((Array.isArray(initField) && initField?.some(item => item === key)) || initField === key) {
        if ((initField === 'searchData') && !acc.searchData && value) {
            acc.searchData += 1;
            acc.total += 1;
            return;
        }
        if (initField === 'licensingType' && value === 'all') return;

        if ((Array.isArray(value) && value?.length) || (dayjs.isDayjs(value) && value)) {
            acc[name] += 1;
            acc.total += 1;
            return;
        }

        if ((typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') && value) {
            acc[name] += 1;
            acc.total += 1;
            return;
        }

        for (const el in value) {
            if (Object.hasOwnProperty.call(value, el) && value[el]) {
                acc[name] += 1;
                acc.total += 1;
            }
        }
    }
};
